import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';
import Card from './Card.vue';

export const PracovniPozice = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Card,
	},
};
